import React, { createContext, useState, useMemo } from "react";

export const ExperimentContext = createContext();

export const ExperimentProvider = ({ children }) => {
  const [experimentId, setExperimentId] = useState(null);
  const value = useMemo(() => ({ experimentId, setExperimentId }), [experimentId]);
  return <ExperimentContext.Provider value={value}>{children}</ExperimentContext.Provider>;
};
